import React from "react";

import { Skeleton } from "@common/skeleton";
import { TaskCompletionStatus } from "@common/taskCompletionStatus";
import { RecordList } from "../../recordList";
import { Props } from "./types";
import styles from "./styles.scss";

function Task(_: Props) {
  return (
    <div className={styles.list}>
      <div className={styles.main}>
        <div className={styles.header} style={{ paddingLeft: `13rem` }}>
          <div>
            <TaskCompletionStatus endDate="" progress={0} />
          </div>
          <Skeleton className={styles.name} />
        </div>
        <div className={styles.recordList}>
          <RecordList type="task" />
        </div>
      </div>
    </div>
  );
}

export { Task };
